import React from "react";
import {connect} from "react-redux";
import {Form, Formik} from "formik";
import {Link} from "react-router-dom";
import {traerPalabrasTabla} from "../../../_actions";
import {prepareDataSearch,} from "../../../_helpers";
import {ventasService} from "../../../_services";
import {buscadorConstants} from "../../../_constants";
import Moment from "react-moment";
import {busquedaActions} from "../../../_actions/busqueda.actions";
import MiTabla from "../../../_helpers/MiTabla";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {NavBarLateral} from "../NavBarLateral";
import {CompraDP} from "./utils/ventasUtils";
import { NumericFormat as NumberFormat } from "react-number-format";
import alertService from "../../../_services/cart/alert.service";
import FiltrosDashboard from "../../includes/FiltrosDashboard";
import authService from "../../../_services/cart/authService";
import ventaService from "../../../_services/cart/ventaService";
import {linkWhatsappVendedor} from "./utils/estadosVenta";

const tableRefCompras = React.createRef();
const bagRefVentas = React.createRef();
const bagRef = React.createRef();
const _ = require("lodash");

class ComprasList extends React.Component {
    constructor(props) {
        super(props);
        this.state.nuevo = _.clone(buscadorConstants.infoTablaDefault);
    }

    state = {
        loading: false,
        nuevaBusqueda: false,
        show: false,
        producto: {},
        showProductModal: false
    };

    componentDidMount() {
        const {filtros} = this.props;

        if (filtros === undefined) this.props.traerFiltros();
    }

    actualizarPageSize = (newPageSIze) => {
        if (tableRefCompras.current) {
            tableRefCompras.current.dataManager.changePageSize(newPageSIze)
        }
    };

    actualizar = () => {
        if (tableRefCompras.current) {
            tableRefCompras.current.onQueryChange();
        }
    };

    handleClose = () => {
        this.setState({
            showProductModal: false,
            producto: undefined,
            alert: undefined,
        });
    };

    buscarData = (query) => {
        return new Promise((resolve, reject) => {
            if (this.state.nuevaBusqueda) query.page = 0;

            ventasService
                .buscarMisCompras(
                    prepareDataSearch(query, "createdDate", "DESC", this.state.values)
                )
                .then(
                    (data) => {
                        this.setState({nuevaBusqueda: false});
                        resolve({
                            data: data.content ? data.content : [],
                            page: query.page,
                            totalCount: data ? data.totalElements : 0,
                        });
                        this.actualizarPageSize(query.pageSize);
                    },
                    (error) => {
                        alertService.error(error);
                    }
                );
        });
    };

    render() {
        const {filtros} = this.props;

        const {loading} = this.state;

        const header = [
            {title: "ID", field: "id", cellStyle: { width: '2%' } },
            {
                title: "Vendedor",
                field: "vendedor.username",
                render: (row) => {
                    return authService.formatUserName(row.vendedor);
                },
            },
            {
                title: "Cantidad productos",
                // En mobile no entra en la card: el dato completo esta en el detalle.
                mobile: false,
                // `cantidad` no existe en Venta: el numero sale de items.length en el front,
                // asi que la columna no puede ordenarse contra la DB.
                sorting: false,
                render: (row) => {
                    return row.items.length;
                }, cellStyle: { width: '2%' }
            },
            {
                title: "Total",
                field: "total",
                render: (row) => {
                    return (
                        <NumberFormat
                            prefix={"$"}
                            value={row.total}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                        />
                    );
                },
            },

            {title: "Estado", field: "estado", render: (row) => (ventaService.formatEstado(row.estado))},
            {
                title: "Fecha Venta",
                field: "createdDate",
                render: (row) => (
                    <Moment date={row.createdDate} format="DD/MM/YYYY HH:mm"/>
                ),
            },
            {
                title: "",
                cellStyle: {width: "1%", whiteSpace: "nowrap", textAlign: "center"},
                render: (row) => {
                    const whatsapp = linkWhatsappVendedor(row);

                    return (
                        <div className="table-button ventas__acciones">
                            <Link to={"/comprador/compraDetail?id=" + row.id} title="Ver el detalle">
                                <FontAwesomeIcon className={'button'} data-type={'complementary-smallest'}
                                                 icon="fa-solid fa-eye"></FontAwesomeIcon>
                            </Link>

                            {/* Sin número no se dibuja: un link a un teléfono vacío abre WhatsApp
                                igual y el comprador se entera recién con el chat en blanco. */}
                            {whatsapp && (
                                <a href={whatsapp} target="_blank" rel="noreferrer"
                                   title="Escribirle por WhatsApp">
                                    {/* Verde: es lo que lo separa de un vistazo del ojo de "ver". */}
                                    <FontAwesomeIcon className={'button'} data-type={'message-smallest'}
                                                     icon="fa-brands fa-whatsapp"/>
                                </a>
                            )}
                        </div>
                    );
                },
            },
        ];

        const tableStyle = {
            tableLayout: "auto",
            width: "100%",
            maxWidth: "100%",
            height: "auto",
            borderRadius: "1rem",
            border: "1px solid #d2d2d2",
            boxShadow: 'none',
            backgroundColor: 'inherit',
            color: 'inherit'
        }

        const options = {
            search: true,
            sorting: true,
            fontSize: 6,
            filtering: false,
            selection: false,
            pageSize: 10,
            pageSizeOptions: [5, 10, 25, 30, 50, 75, 100],
            exportAllData: true,
            overflowX: "auto",
            tableLayout: "auto",
        };

        let inic = {};

        return (
            <>
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>
                    <div className="dashboard__content">
                        <Formik
                            enableReinitialize={true}
                            innerRef={bagRef}
                            initialValues={inic}
                            onSubmit={(values) => {
                                this.setState(
                                    {
                                        values: values,
                                        nuevaBusqueda: true,
                                    },
                                    this.actualizar
                                );
                            }}
                        >
                            {({values, setFieldValue, submitForm}) => (
                                <Form>
                                    <div className="dashboard__content-header">
                                        <div className="dashboard__content-title">
                                            <h2>Mis Compras</h2>
                                        </div>
                                    </div>

                                    <div className="filter__container">
                                        <FiltrosDashboard
                                            forVenta={true}
                                            values={values}
                                            filtros={filtros}
                                            setFieldValue={setFieldValue}
                                            submitForm={submitForm}
                                        ></FiltrosDashboard>
                                    </div>

                                    <div className="dashboard__content-main--tab">
                                        <MiTabla
                                            title=""
                                            tableRef={tableRefCompras}
                                            columns={header}
                                            options={options}
                                            style={tableStyle}
                                            data={(query) => this.buscarData(query, false)}
                                            detailPanel={(rowData) => {
                                                return <CompraDP rowData={rowData}/>;
                                            }}
                                            localization={traerPalabrasTabla("Compras")}
                                        />
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        {this.state.alert}
                    </div>
                </div>
            </>
        );
    }
}

function mapState(state) {
    const {filtros} = state.busqueda;
    return {filtros};
}

const actionCreators = {
    traerFiltros: busquedaActions.traerFiltros,
};

const connectedComprasList = connect(mapState, actionCreators)(ComprasList);
export {connectedComprasList as ComprasList};
